export default __webpack_public_path__ + "static/media/model_training_FILL0_wght400_GRAD0_opsz24.2d53795d.svg";